export const IDS = {
  itemPickerRootId: 'item-picker-root-id',
  itemPickerTestId: 'item-picker-root',
}
